import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from './supabaseClient'
import { Icon } from '@iconify/react'

export default function Login({ onLogin }) {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [focusedField, setFocusedField] = useState(null)
  const [mensagem, setMensagem] = useState({ texto: '', tipo: '' }) // tipo: 'erro', 'sucesso'

  // Validar se o formulário está completo
  const isFormValid = email.trim() !== '' && password.trim() !== ''

  // Traduzir mensagens de erro do Supabase
  const traduzirErro = (mensagem) => {
    if (mensagem.includes('Invalid login credentials')) {
      return 'E-mail ou senha incorretos'
    }
    if (mensagem.includes('Email not confirmed')) {
      return 'E-mail não confirmado. Verifique sua caixa de entrada.'
    }
    if (mensagem.includes('Too many requests')) {
      return 'Muitas tentativas. Aguarde alguns minutos.'
    }
    if (mensagem.includes('User not found')) {
      return 'Usuário não encontrado'
    }
    if (mensagem.includes('Database error')) {
      return 'Erro no servidor. Tente novamente em alguns instantes.'
    }
    return mensagem
  }

  const handleAuth = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMensagem({ texto: '', tipo: '' })

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password
      })

      if (error) throw error

      // Chamar callback e redirecionar
      if (onLogin) onLogin()
      navigate('/app/home')
    } catch (error) {
      setMensagem({ texto: traduzirErro(error.message), tipo: 'erro' })
    } finally {
      setLoading(false)
    }
  }

  const handleForgotPassword = async () => {
    if (!email) {
      setMensagem({ texto: 'Por favor, digite seu e-mail primeiro', tipo: 'erro' })
      return
    }

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`
      })

      if (error) throw error
      setMensagem({ texto: 'Email de recuperação enviado! Verifique sua caixa de entrada.', tipo: 'sucesso' })
    } catch (error) {
      setMensagem({ texto: 'Erro ao enviar email: ' + error.message, tipo: 'erro' })
    }
  }

  // Login Social
  const handleSocialLogin = async (provider) => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: provider,
        options: {
          redirectTo: `${window.location.origin}/app/home`
        }
      })
      if (error) throw error
    } catch (error) {
      setMensagem({ texto: 'Erro ao conectar com ' + provider, tipo: 'erro' })
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src="/icone.svg" alt="ClickPag" style={{ height: '48px', width: 'auto' }} />
        </div>
        <h2 className="auth-title">
          Boas vindas!
        </h2>

        {/* Botões de Login Social */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
          <button
            onClick={() => handleSocialLogin('google')}
            className="auth-social-btn"
          >
            <Icon icon="logos:google-icon" width="20" height="20" />
            Continuar com Google
          </button>

          <button
            onClick={() => handleSocialLogin('facebook')}
            className="auth-social-btn facebook"
          >
            <Icon icon="logos:facebook" width="20" height="20" color="white" />
            Continuar com Facebook
          </button>
        </div>

        <div className="auth-divider">
          <div className="auth-divider-line"></div>
          <span className="auth-divider-text">ou entre com e-mail</span>
          <div className="auth-divider-line"></div>
        </div>

        <form onSubmit={handleAuth}>
          {/* Campo E-mail */}
          <div className="auth-input-container">
            <label className="auth-label">
              E-mail
            </label>
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center',
                pointerEvents: 'none'
              }}>
                <Icon icon="ph:envelope-simple" width="20" height="20" className="auth-icon" />
              </div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="auth-input"
                style={{ paddingLeft: '40px' }}
                onFocus={() => setFocusedField('email')}
                onBlur={() => setFocusedField(null)}
              />
            </div>
          </div>

          {/* Campo Senha */}
          <div className="auth-input-container">
            <label className="auth-label">
              Senha
            </label>
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center',
                pointerEvents: 'none'
              }}>
                <Icon icon="ph:lock-key" width="20" height="20" className="auth-icon" />
              </div>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Sua senha"
                required
                className="auth-input"
                style={{ paddingLeft: '40px', paddingRight: '40px' }}
                onFocus={() => setFocusedField('password')}
                onBlur={() => setFocusedField(null)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Icon 
                  icon={showPassword ? 'ph:eye-slash' : 'ph:eye'} 
                  width="20" 
                  height="20" 
                  className="auth-icon"
                />
              </button>
            </div>
          </div>

          {/* Mensagem de erro/sucesso */}
          {mensagem.texto && (
            <div style={{
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '16px',
              fontSize: '14px',
              backgroundColor: mensagem.tipo === 'erro' ? 'rgba(220, 38, 38, 0.1)' : 'rgba(22, 163, 74, 0.1)',
              color: mensagem.tipo === 'erro' ? '#ef4444' : '#22c55e',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <Icon icon={mensagem.tipo === 'erro' ? 'ph:warning-circle' : 'ph:check-circle'} width="20" />
              {mensagem.texto}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !isFormValid}
            className="auth-button"
            style={{ opacity: loading || !isFormValid ? 0.7 : 1 }}
          >
            {loading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <Icon icon="ph:spinner" className="animate-spin" />
                Entrando...
              </div>
            ) : 'Entrar na plataforma'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <span 
            onClick={handleForgotPassword}
            className="auth-link"
          >
            Esqueci minha senha
          </span>
        </div>
      </div>

      <div className="auth-footer">
        Não tem uma conta?{' '}
        <span 
          onClick={() => navigate('/signup')}
          className="auth-link"
          style={{ fontWeight: '600' }}
        >
          Cadastre-se
        </span>
      </div>
    </div>
  )
}
